import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NotificationPreferences } from '../../model/notification-preference';
import { Output, EventEmitter } from '@angular/core';
import { NotificationPreferencesFormData } from '../../model/form-data';

@Component({
    selector: 'vb-create-notification-preferences',
    templateUrl: './create-notification-preferences.component.html',
    styleUrls: ['./create-notification-preferences.component.scss'],
})
export class CreateNotificationPreferencesComponent implements OnInit {
    @Output() notificationPrefSelectedEvent =
        new EventEmitter<NotificationPreferencesFormData>();

    allNotificationPreferences = NotificationPreferences;
    notificationPreferences: string[] = [
        NotificationPreferences.All.toString(),
        NotificationPreferences.TEXT_ONLY.toString(),
        NotificationPreferences.EMAIL_ONLY.toString(),
    ];
    notificationPrefFormGroup = this._formBuilder.group({
        notificationPref: ['', Validators.required],
    });
    isFormValid = true;

    constructor(private _formBuilder: FormBuilder) {}
    ngOnInit(): void {
        this.notificationPrefFormGroup.controls.notificationPref.setValue(
            NotificationPreferences.EMAIL_ONLY.toString(),
        );
    }

    validate(): boolean {
        this.notificationPrefFormGroup.markAllAsTouched();
        return this.notificationPrefFormGroup.valid;
    }

    onSubmit(): void {
        this.isFormValid = this.notificationPrefFormGroup.valid;
        if (
            this.isFormValid &&
            this.notificationPrefFormGroup.controls.notificationPref.value !=
                null
        ) {
            const value: NotificationPreferences = this
                .notificationPrefFormGroup.controls.notificationPref
                .value as NotificationPreferences;
            this.notificationPrefSelectedEvent.emit({
                preferences: value,
            });
        }
    }
}
